import React, { useEffect, useState } from "react";
import { api, apiErr } from "../../lib/api";
import { Loader2, ExternalLink, FileText } from "lucide-react";
import Markdown from "../../components/Markdown";
import { cacheGet, cacheSet } from "../../lib/cache";

export default function SamplePapersTab({ cls, subject, chapterId }) {
  const cacheKey = `papers:${cls}:${subject}:${chapterId}`;
  const [data, setData] = useState(() => cacheGet(cacheKey));
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(!cacheGet(cacheKey));

  useEffect(() => {
    const cached = cacheGet(cacheKey);
    setData(cached);
    setLoading(!cached);
    setErr(null);
    api.get(`/sample-papers/${cls}/${subject}/${chapterId}`)
      .then((r) => { setData(r.data); cacheSet(cacheKey, r.data); })
      .catch((e) => { if (!cached) setErr(apiErr(e)); })
      .finally(() => setLoading(false));
  }, [cls, subject, chapterId, cacheKey]);

  if (loading && !data) return (
    <div className="brut-card p-8 mt-4 bg-white flex items-center gap-3">
      <Loader2 className="animate-spin" strokeWidth={2.5}/>
      <span className="font-bold">Generating sample board paper questions…</span>
    </div>
  );
  if (err && !data) return <div className="brut-card p-6 mt-4 bg-[#FFB3BA]">{err}</div>;

  return (
    <div className="mt-4 space-y-4">
      <div className="brut-card p-6 sm:p-8 bg-white" data-testid="papers-content">
        <div className="flex items-center gap-2 mb-2">
          <div className="text-xs font-bold tracking-[0.2em] uppercase">Sample Board Paper Questions</div>
          {loading && <Loader2 size={14} className="animate-spin" strokeWidth={2.5}/>}
        </div>
        <Markdown>{data?.content}</Markdown>
      </div>

      {data?.resources?.length > 0 && (
        <div className="brut-card p-6 bg-[#FFF5D1]">
          <div className="text-xs font-bold tracking-[0.2em] uppercase mb-3">Owner-uploaded Resources</div>
          <div className="space-y-3">
            {data.resources.map((r) => (
              <div key={r.id} className="brut-border bg-white p-3" data-testid={`resource-${r.id}`}>
                <div className="flex items-center gap-2 font-bold">
                  <FileText size={16} strokeWidth={2.5}/>
                  {r.title}
                </div>
                {r.resource_type === "link" ? (
                  <a href={r.content} target="_blank" rel="noreferrer" className="text-sm underline inline-flex items-center gap-1 mt-1">
                    Open link <ExternalLink size={12} strokeWidth={2.5}/>
                  </a>
                ) : (
                  <div className="text-sm mt-1 whitespace-pre-wrap">{r.content}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
